import React from "react";
import Hero from "./HeroSlice";
import InfoBlocks from "./InfoBlocksSlice";
import ColumnCopyImage from "./ColumnCopyImageSlice";
import CopyImageSlice from "./CopyImageSlice";
import GradientInfo from "./GradientInfoSlice";
import ThreeInfoBlocks from "./ThreeInfoBlocksSlice";
import StoreInfo from "./StoreInfoSlice";
import TextSlice from "./TextSlice";
import BackgroundImageCallout from "./BackgroundImgCallout";
import SplitHero from "./SplitHero";

export default function Slices(props) {
  if (!document) {
    return null;
  }

  return props.slices.map((slice, index) => (
    <div key={index}>
      {slice.slice_type === "hero" && Hero(slice)}
      {slice.slice_type === "info_blocks" && InfoBlocks(slice)}
      {slice.slice_type === "info_block_section" && ThreeInfoBlocks(slice)}
      {slice.slice_type === "column_copy_image" && ColumnCopyImage(slice)}
      {(slice.slice_type === "copy_image" ||
        slice.slice_type === "copy_image_slice") &&
        CopyImageSlice(slice)}
      {slice.slice_type === "gradient_info" && GradientInfo(slice)}
      {slice.slice_type === "store_info_slice" && StoreInfo(slice)}
      {slice.slice_type === "text_slice" && TextSlice(slice)}
      {slice.slice_type === "background_image_callout" &&
        BackgroundImageCallout(slice)}
      {slice.slice_type === "split_hero" && SplitHero(slice)}
    </div>
  ));
}
